import { Baggu } from './Baggu';
import { Better } from './Better';
import { Bombas } from './Bombas';
import { BostonConsultingGroup } from './BostonConsultingGroup';
import { Branch } from './Branch';
import { Carta } from './Carta';
import { Clickup } from './Clickup';
import { CSW } from './CSW';
import { CultureAmp } from './CultureAmp';
import { Echo } from './Echo';
import { Essentialist } from './Essentialist';
import { GoDaddy } from './GoDaddy';
import { Hootsuite } from './Hootsuite';
import { IHG } from './IHG';
import { MongoDb } from './MongoDb';
import { Navan } from './Navan';
import { OpenAi } from './OpenAi';
import { Reddit } from './Reddit';
import { ReedAndMackay } from './ReedAndMackay';
import { Spruce } from './Spruce';
import { Stripe } from './Stripe';
import { Supacolor } from './Supacolor';
import { UberFreight } from './UberFreight';
import { UHaul } from './UHaul';
import { YCombinator } from './YCombinator';
import { Zoom } from './Zoom';

export const LogoNames = {
  Baggu: Baggu,
  Better: Better,
  Bombas: Bombas,
  BostonConsultingGroup: BostonConsultingGroup,
  Branch: Branch,
  Carta: Carta,
  Clickup: Clickup,
  CSW: CSW,
  CultureAmp: CultureAmp,
  Echo: Echo,
  Essentialist: Essentialist,
  GoDaddy: GoDaddy,
  Hootsuite: Hootsuite,
  IHG: IHG,
  MongoDb: MongoDb,
  Navan: Navan,
  OpenAi: OpenAi,
  Reddit: Reddit,
  ReedAndMackay: ReedAndMackay,
  Spruce: Spruce,
  Stripe: Stripe,
  Supacolor: Supacolor,
  UberFreight: UberFreight,
  UHaul: UHaul,
  YCombinator: YCombinator,
  Zoom: Zoom,
} as const;

export type LogoNameType = keyof typeof LogoNames;

export type LogoProps = {
  type: LogoNameType,
  width?: number,
  height?: number,
  isFullColor?: boolean,
} & React.SVGProps<SVGSVGElement>;

const Logo: React.FC<LogoProps> = ({ type, isFullColor, ...props }) => {
  const LogoComponent = LogoNames[type];

  return (
    <LogoComponent isFullColor={isFullColor} {...props} />
  );
};

export default Logo;
